/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="83.41"
        height="95.59"
        viewBox="0 0 83.41 95.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M82.16 8.55a1.252 1.252 0 0 1 .13 2.5h-81a1.25 1.25 0 0 1-.13-2.49h81Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M76.21 8.55a1.25 1.25 0 0 1 1.29 1.12V62.5a2.44 2.44 0 0 1-2.29 2.43H8.41a2.44 2.44 0 0 1-2.45-2.28V9.8a1.272 1.272 0 0 1 2.54-.13V62.5h66.51V9.8a1.24 1.24 0 0 1 1.12-1.24Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M53.08 62.71a1.25 1.25 0 0 1 1.57.58l.06.11 12.31 30.39a1.25 1.25 0 0 1-2.26 1.06l-.06-.12-12.31-30.39a1.25 1.25 0 0 1 .69-1.63ZM28.58 63.4a1.25 1.25 0 0 1 2.36.82v.12L18.56 94.81a1.25 1.25 0 0 1-2.36-.82v-.12ZM41.7 0a1.26 1.26 0 0 1 1.25 1.12V9.8a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 41.7 0ZM41.7 62.5a1.26 1.26 0 0 1 1.25 1.12v30.69a1.25 1.25 0 0 1-2.49.13V63.7a1.25 1.25 0 0 1 1.24-1.2Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M44.67 33.93H58.9A15 15 0 0 0 44.67 19.7Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M44.71 18.95a.75.75 0 0 0-.79.75v14.23a.75.75 0 0 0 .75.75H58.9a.75.75 0 0 0 .75-.78 15.75 15.75 0 0 0-14.94-14.95Zm.71 1.55h.19A14.25 14.25 0 0 1 58.07 33v.18H45.42Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M38.7 24.18a15 15 0 1 0 15.7 15.71h-15a.74.74 0 0 1-.73-.74Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M38.66 23.43a15.74 15.74 0 1 0 16.49 16.5v-.1a.75.75 0 0 0-.75-.69H39.5v-15a.76.76 0 0 0-.84-.71Zm-.71 1.56V39.3a1.49 1.49 0 0 0 1.48 1.34h14.16v.16a14.24 14.24 0 1 1-15.8-15.79Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ProjectorScreenWithPieChartIcon';

export default Icon;
